module.exports = __webpack_public_path__ + "static/media/loader_img.7b5d974b.gif";